import { Card, Col, Row } from "antd";
import { useMemo } from "react";
import { theme } from "../../../theme";
import { BodyTypo, StatusTypo } from "./ResultModal.styled";

interface ResultModalProps {
  acceptYn: boolean;
}

/**
 * 타이어 사이즈 설문 결과
 * @param param0
 * @returns
 */
export const ResultModal: React.FC<ResultModalProps> = ({ acceptYn }) => {
  const text = useMemo(
    () => (acceptYn !== undefined ? (acceptYn ? "가능" : "불가능") : "-"),
    [acceptYn]
  );

  return (
    <Row gutter={[0, 18]}>
      <Col span={24}>
        아래와 같이 정비가능항목이 변경되었어요.
        <br />
        변경을 원하시면 [설정 - 매장 정보]에서 변경하실 수 있어요.
      </Col>
      <Col span={24}>
        <Card bodyStyle={{ background: theme.colors.gray9 }}>
          <Row gutter={[0, 8]}>
            <Col span={24}>
              <Row justify="space-between">
                <Col>
                  <BodyTypo>19인치 이하</BodyTypo>
                </Col>
                <Col>
                  <StatusTypo status>가능</StatusTypo>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="space-between">
                <Col>
                  <BodyTypo>20인치</BodyTypo>
                </Col>
                <Col>
                  <StatusTypo status={acceptYn}>{text}</StatusTypo>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="space-between">
                <Col>
                  <BodyTypo>21인치</BodyTypo>
                </Col>
                <Col>
                  <StatusTypo status={acceptYn}>{text}</StatusTypo>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="space-between">
                <Col>
                  <BodyTypo>22인치 이상</BodyTypo>
                </Col>
                <Col>
                  <StatusTypo status={acceptYn}>{text}</StatusTypo>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};
